<template>
  <div class="main-container">
    <header-menu v-if="isActiveMenu && !$isMobile"/>
    <menu-mobile v-if="isActiveMenu && $isMobile"/>
    <div class="main-content">
      <main-menu v-if="isActiveMenu && !$isMobile"/>
      <router-view/>
    </div>
  </div>
</template>

<script>
import HeaderMenu from "@/components/widgets/HeaderMenu.vue";
import MainMenu from "@/components/widgets/MainMenu.vue";
import MenuMobile from "@/components/widgets/MenuMobile.vue";

export default {
  name: "AuthLayout",
  components: {MenuMobile, MainMenu, HeaderMenu},
  computed: {
    isActiveMenu() {
      return this.nameRout !== 'error';
    }
  }
}
</script>

<style scoped lang="scss">
.main-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  justify-content: flex-start;
  .main-content {
    height: var(--calc-height);
    padding-top: 88px;
    display: flex;
    flex-direction: row;
    overflow-x: hidden;
    width: 100%;
  }
}
</style>